// A miniature of the app drawn only from real tokens, for the Settings theme tiles. The wrapper is a
// .theme-scope carrying its own data-ui-theme / data-theme / data-palette, so tokens.css re-derives the
// whole chain inside it: each tile shows "this theme, in my light or dark and my colour", whatever theme
// the page itself is in. Purely decorative (aria-hidden); the tile's label names the theme.

import type { UiThemeId } from '../lib/themes.js';
import type { PaletteId } from '../lib/palettes.js';

export function ThemePreview({ theme, mode, palette }: { theme: UiThemeId; mode: 'light' | 'dark'; palette: PaletteId }) {
  return (
    <span className="theme-scope tmini" data-ui-theme={theme} data-theme={mode} data-palette={palette} aria-hidden="true">
      <span className="tmini-bar"><i className="tmini-mark" /><i className="tmini-search" /></span>
      <span className="tmini-body">
        <span className="tmini-rail"><i /><i className="on" /><i /><i /></span>
        <span className="tmini-page">
          <span className="tmini-title"><span lang="el">Αα</span> Aa</span>
          <span className="tmini-card">
            <span className="tmini-row">
              <i className="tmini-pill ok" /><i className="tmini-pill warn" /><i className="tmini-pill err" /><i className="tmini-chip" />
            </span>
            {/* the journey strip: two done, one under way, the rest to do */}
            <span className="tmini-journey"><i className="d" /><i className="d" /><i className="c" /><i /><i /><i /><i /></span>
            <span className="tmini-row tmini-row--end"><i className="tmini-btn" /></span>
          </span>
        </span>
      </span>
    </span>
  );
}
